<form>
  <!-- Modal Header -->
  @if (isModal == true) {
    <div class="modal-header">
      <h4 class="modal-title">Process Commission Limit</h4>
      <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
    </div>
  }

  <div class="modal-body">
    @if (loanGroup != undefined) {
      <div class="card">
        <div class="card-body">
          <table class="table">
            <tr>
              <th>Name</th>
              <td>{{ loan.CustomerName }} | {{ sharedService.processICNum(loan.ICNumber) }}</td>
            </tr>
            <tr>
              <th>Principal</th>
              <td>RM {{ loan.Principal }} | {{ loan.Scheme }}</td>
            </tr>
            <tr>
              <th>Current Limit</th>
              <td>{{ loanGroup.CommissionRateLimit }}%</td>
            </tr>
          </table>
          <hr />
          <app-previous-assigned-commission [assignedCommisionList]="assignedCommissionList"></app-previous-assigned-commission>
        </div>
      </div>

      <!--Amount-->
      <div class="group mt-3">
        <input type="number" required class="textInputLong" name="commLimit" [(ngModel)]="commLimit" min="0" (keypress)="sharedService.isNumberKey($event)" />
        <span class="highlight"></span>
        <span class="bar barLong"></span>
        <label>Commission Limit (%)</label>
        @if (commLimit > maxCommRate) {
          <p class="text-danger p-0 m-0">The commission requested over limit! ({{ maxCommRate }}%)</p>
        }
      </div>

      <mat-form-field class="full-width-formField bar">
        <mat-label>Update Remark</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10" [(ngModel)]="remark" name="remark"></textarea>
      </mat-form-field>
    }
  </div>

  <div class="modal-footer">
    @if (commLimit <= maxCommRate) {
      <button class="btn btn-outline-success" type="button" (click)="confirmBeforeUpdate()">Update</button>
    }
    <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
  </div>
</form>
